import {Component, inject, Input, OnInit} from '@angular/core';
import {NgApexchartsModule} from 'ng-apexcharts';
import {MaterialModule} from 'src/app/material.module';
import {MasterThreadService} from "../../../services/objects/master-thread.service";
import {IConversation} from "../../../models/conversation.model";
import {DatePipe} from "@angular/common";
import {RouterLink} from "@angular/router";

@Component({
    selector: 'app-recent-conversations',
    standalone: true,
    imports: [NgApexchartsModule, MaterialModule, DatePipe, RouterLink],
    templateUrl: './recent-conversations.component.html',
})
export class AppRecentConversationsComponent implements OnInit {
    private masterDataService = inject(MasterThreadService);


    @Input() chatbotId: string = '';

    chats: IConversation[] = [];
    private colorMap: Record<string, string> = {};

    ngOnInit(): void {
        this.loadStats();
    }

    loadStats(): void {
        this.masterDataService.getMasterThreadsForChatbotAsync(this.chatbotId, 13).subscribe(
            (data) => {
                // sort data by last modified date and keep the top 10
                console.log(data);
                data = data.filter(x => x.messages[0]?.user);
                const sorted = data.sort((a, b) => {
                    const dateA = new Date(a.lastModified).getTime();
                    const dateB = new Date(b.lastModified).getTime();
                    return dateB - dateA; // Descending order
                }).slice(0, 10);
                // Initialize stable colors before assigning to chats
                sorted.forEach(item => {
                    const id = item.id;
                    if (id && !this.colorMap[id]) {
                        this.colorMap[id] = this.pickColor();
                    }
                });
                this.chats = sorted;
            },
            (error) => {
                console.error('Error fetching stats', error);
            }
        );
    }

    pickColor(): string {
        const colors = ["accent", "primary", "success", "warning"];
        return colors[Math.floor(Math.random() * colors.length)];
    }

    colorFor(id: string): string {
        return this.colorMap[id] || 'primary';
    }
}
